const ENDPOINT = new Map();

ENDPOINT.set('list', '/recordings');
ENDPOINT.set('access', '/recordings/access');

export default ENDPOINT;
